import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { TerminePage } from './pages/TerminePage';
import { MediathekPage } from './pages/MediathekPage';
import { KontaktPage } from './pages/KontaktPage';
import { ImpressumPage } from './pages/ImpressumPage';
import { DatenschutzPage } from './pages/DatenschutzPage';
import { CourseDetailPage } from './pages/CourseDetailPage';
import { SpeakerDetailPage } from './pages/SpeakerDetailPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/termine" element={<TerminePage data-id="element-5" />} data-id="element-4" />
        <Route path="/mediathek" element={<MediathekPage data-id="element-7" />} data-id="element-6" />
        <Route path="/kontakt" element={<KontaktPage data-id="element-9" />} data-id="element-8" />
        <Route path="/impressum" element={<ImpressumPage data-id="element-11" />} data-id="element-10" />
        <Route path="/datenschutz" element={<DatenschutzPage data-id="element-13" />} data-id="element-12" />
        <Route path="/kurse/:slug" element={<CourseDetailPage data-id="element-15" />} data-id="element-14" />
        <Route path="/referenten/:slug" element={<SpeakerDetailPage data-id="element-17" />} data-id="element-16" />
      </Routes>
    </BrowserRouter>;
}